import { render, staticRenderFns } from "./GJgrowEventCreateQuestionSetting.vue?vue&type=template&id=8b40ed62&scoped=true&"
import script from "./GJgrowEventCreateQuestionSetting.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateQuestionSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GJgrowEventCreateQuestionSetting.vue?vue&type=style&index=0&id=8b40ed62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b40ed62",
  null
  
)

export default component.exports